import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface ConfirmationSettings {
    title: string;
    message: string;
}

/**
 * @deprecated - this can be replaced with the confirmation dialog service
 */
@Component({
    selector: 'nova-job-fulfillment-type-selector-confirmation',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="nova__dialog__toolbar">
            <div class="nova__dialog__toolbar__title">
                {{ model.title }}
            </div>
        </div>
        <div
            mat-dialog-content
            class="nova__dialog__content">
            <div [innerHTML]="model.message"></div>
            <mat-dialog-actions class="nova__dialog__content__actions">
                <button
                    mat-flat-button
                    color="primary"
                    data-qa-id="jobFulfillmentTypeConfirmBtn"
                    [mat-dialog-close]="true"
                    >Yes</button
                >
                <button
                    mat-flat-button
                    color="cancel"
                    data-qa-id="jobFulfillmentTypeConfirmCancelBtn"
                    [mat-dialog-close]="false"
                    cdkFocusInitial
                    >No, Cancel</button
                >
            </mat-dialog-actions>
        </div>
    `
})
export class JobFulfillmentTypeSelectorConfirmationComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public model: ConfirmationSettings) {}
}
